import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Chip, Paper, Snackbar, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import AdminService from '../../services/AdminService';

const STATUS_COLORS = { approved: 'success', rejected: 'error', pending: 'warning' };

export default function TemplatesAdminView() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  useEffect(() => {
    AdminService.getAllTemplates()
      .then((data) => setTemplates(data || []))
      .catch(() => setSnackbar({ open: true, message: 'Failed to load templates', severity: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} mb={2}>Templates</Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Service ID</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Language</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={7} align="center">Loading…</TableCell></TableRow>
            ) : templates.length === 0 ? (
              <TableRow><TableCell colSpan={7} align="center">No templates found</TableCell></TableRow>
            ) : templates.map((t) => (
              <TableRow key={t.id} hover>
                <TableCell>{t.template_name}</TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{t.service_id}</TableCell>
                <TableCell>{t.template_type || '—'}</TableCell>
                <TableCell>{t.template_language || '—'}</TableCell>
                <TableCell>{t.template_event || '—'}</TableCell>
                <TableCell>
                  <Chip label={t.status} color={STATUS_COLORS[t.status] || 'default'} size="small" />
                </TableCell>
                <TableCell>{t.created_at ? new Date(t.created_at).toLocaleDateString() : '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
